import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/api";
import Seo from "@/components/store/Seo";

export function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);
  return (
    <div className="tq-container py-12 sm:py-16" data-testid="blog-page">
      <Seo title="The Journal" description="Footwear styling guides, care tips & stories from the TARISHQ atelier." />
      <div className="text-center mb-12">
        <p className="tq-overline mb-2">TARISHQ Journal</p>
        <h1 className="font-serif text-4xl sm:text-5xl">Stories & Styling</h1>
      </div>
      {!posts ? (
        <div className="grid sm:grid-cols-2 gap-8 max-w-4xl mx-auto">{[...Array(2)].map((_, i) => <div key={i} className="aspect-[16/10] bg-[#FAFAFA] animate-pulse" />)}</div>
      ) : posts.length === 0 ? (
        <p className="text-center text-[#666666] py-12">New stories coming soon.</p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group">
              <div className="aspect-[16/10] overflow-hidden bg-[#FAFAFA]">
                {p.image && <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
              </div>
              <p className="tq-overline mt-4">{p.category}</p>
              <h2 className="font-serif text-2xl mt-1.5 group-hover:text-[#A8821B] transition-colors">{p.title}</h2>
              <p className="text-sm text-[#666666] mt-2 line-clamp-2">{p.excerpt}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setError(true)); }, [slug]);
  if (error) return <div className="tq-container py-24 text-center"><h1 className="font-serif text-4xl mb-4">Story not found</h1><Link to="/blog" className="tq-btn-dark">Back to Journal</Link></div>;
  if (!post) return <div className="tq-container py-16 max-w-3xl"><div className="h-64 bg-[#FAFAFA] animate-pulse" /></div>;
  return (
    <article className="tq-container py-12 sm:py-16 max-w-3xl" data-testid="blog-post-page">
      <Seo title={post.seo?.title?.replace(" | TARISHQ Journal", "") || post.title} description={post.seo?.description || post.excerpt} image={post.image} />
      <p className="tq-overline mb-3">{post.category}</p>
      <h1 className="font-serif text-4xl sm:text-5xl leading-tight mb-4">{post.title}</h1>
      <p className="text-xs text-[#8E8E93] uppercase tracking-wider mb-8">By {post.author} · {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
      {post.image && <img src={post.image} alt={post.title} className="w-full aspect-[16/9] object-cover mb-10" />}
      <div className="text-[#333] leading-[1.9] space-y-5 text-[15px]" dangerouslySetInnerHTML={{ __html: post.content }} />
      <div className="mt-12 pt-8 border-t border-[#EAEAEA] text-center">
        <p className="font-serif text-2xl mb-4">Step into the story</p>
        <Link to="/collections/new-arrivals" className="tq-btn-gold">Shop the Collection</Link>
      </div>
    </article>
  );
}
